<template v-bind:is="currentTabComponent" >

   <spinner v-if="!loaded" ></spinner>


    <div class="page p-4 mt-2" v-else-if="loaded" >
        
        <div class="col-12" >
            
            <div class="row graymedium-color font-size-14" >
                <div class="col" > <font-awesome-icon icon="user" /> ORGANIZATION </div>
                <div class="col text-right"  > <span class="cursor-pointer" @click="copy(data.id)" > {{data.id}} <font-awesome-icon icon="copy" v-if="data.id != '' "  ></font-awesome-icon> </span> </div>
            </div>
            
            <div class="row page-section" >
                <div class="col-12 page-section-heading" >
                    
                    <h1 class="h1 text-bold pb-3 d-inline-block" > 
                        <span class="" >
                            <span class="not-active text-bold d-inline-block" > {{data.name}} </span> 
                            <font-awesome-icon icon="copy" v-if="data.name != '' " class="cursor-pointer graymedium-color h4" @click="copy(data.name)" ></font-awesome-icon>
                        </span>
                    </h1>
                    
                    <span class="actions-span d-inline-block float-right" >

                    </span>
                </div>
            </div>
            
            <div class="row page-section mt-1" >
                
                <div class="d-inline-block border-right-gray p-2 pl-0 pr-4" >
                    <div> 
                        <span class="graymedium-color font-300" > Revenue: </span> 
                        <br>
                            ${{data.revenue}}
                    </div>
                </div>
                
                <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" >
                    <div> 
                        <span class="graymedium-color font-300" > Created at: </span> 
                        <br>
                            {{formatDate(data.datetime)}} 
                    </div>
                </div>
                
            </div>
    
        </div>
        
    </div>
</template>

<script>
import { AUTH_INTO_ORG } from '@/store/actions/auth'
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'

export default {
    name: 'OrganizationDetails',
    components:{
    },
    props: {
        ID: { 
            type: [Number, String],
        },
        data1: { 
            type: [Object],
        },
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            //docID: this.ID,
            type: 'page'
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        this.get_data();
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
             
            const db = firebase.firestore();
            var ref = db.collection('organizations').doc( this.ID )
            return ref.get()
                .then((snapshot) => {
                    //console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.$parent.data = this.data
                    
                    this.loaded = true;
                })
            
        },
        formatDate(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        copy( text ){
            
            let textToCopy = text
            navigator.clipboard.writeText(textToCopy);
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        },
        logIntoOrganization(){
            let orgID = this.data.id;
            let orgName = this.data.name;
            
            if( firebase.auth().currentUser ){
                firebase
                    .auth()
                    .currentUser.getIdTokenResult()
                    .then(tokenResult => {
                        //console.log(tokenResult.claims);
                        let uid = tokenResult.claims.user_id
                        console.log(uid)
                        let user = firebase
                            .firestore()
                            .collection("users")
                            .doc(uid)

                        user.get().then(function(doc) {
                            if (doc.exists) {
                                console.log("Document data:", doc.data());

                                let user = doc.data()
                                if( user.admin ){
                                    //USER IS ADMIN
                                    //SET COOKIE FOR LOGGED IN ORGANIZATION
                                    let org = {"ID": orgID, "name": orgName}
                                    
                                    this.$store.dispatch(AUTH_INTO_ORG, org ).then(response => {
                                        //this.$router.push({ name: 'Analyze'});
                                    })
                                    //this.$router.push({ name: 'Analyze' });
                                }
                            
                                //Cookies.set('user', btoa( JSON.stringify( doc.data() ) ) , null, null, null, false, true ) 
                                //router.push({ name: 'Onboarding', params: { APPKEY: APPKEY }},);
                            } else {
                                // doc.data() will be undefined in this case
                                console.log("No such document!");

                            }
                        }.bind(this)).catch(function(error) {
                            console.log("Error getting document:", error);
                        });
                    });
            }

        }

    },
    watch: {
   
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/admin/OrganizationDetails.vue